import { RootState } from '@redux/types';

import { QUARTER_HOURS_COUNTS } from './types';

export const sessionEndTimestampSelector = (state: RootState) => state.session?.endTimestamp;

export const activatedVolumeSelector = (state: RootState) => state.session?.activatedVolume;

export const shouldSkipStaffPasswordSelector = (state: RootState) =>
  state.session?.shouldSkipStaffPassword;

export const isStorageActivatedSelector = (state: RootState) => state.session?.isStorageActivated;

export const screenSplitModeSelector = (state: RootState) => state.session?.screenSplitMode;

export const bamSessionModeSelector = (state: RootState) => state.session?.bamSessionMode;

export const getPlaylists = (state: RootState) => {
  return state.session?.customPlaylists;
};

export const bamSessionClientCodeSelector = (state: RootState) =>
  state.session?.bamSessionUser?.clientCode;

export const bamSessionUserSelector = (state: RootState) => state.session?.bamSessionUser;

export const isBamProlongationPossibleSelector = (state: RootState) =>
  state.session?.bamProlongation.isProlongationPossiblePerTimeBlock[
  QUARTER_HOURS_COUNTS.THIRTY_MINUTES
  ];

export const bamProlongationHourPriceSelector = (state: RootState) =>
  state.session.bamProlongation.currentPricePerHour;

export const bamProlongationTimeBlocksSelector = (state: RootState) =>
  state.session?.bamProlongation.isProlongationPossiblePerTimeBlock;

export const isBamProlongationStateChanging = (state: RootState) =>
  state.session?.bamProlongation.isProlongationStateWaitingForChange;

export const remainingSessionTimeInMillisecondsSelector = (state: RootState) =>
  state.session?.remainingSessionTimeInMilliseconds;

export const isVideoRecordingSelector = (state: RootState) => state.session?.isVideoRecording;

export const isSessionStartedSelector = (state: RootState) =>
  state.session?.bamSessionUser?.sessionStarted;

export const favoritePlaylistSelector = (state: RootState) =>
  state.session.customPlaylists?.find(
    (p) => p.name.includes('LIKED_'));
